export default __webpack_public_path__ + "static/Imme_3.2-cae0ca97841662c38c451791d9b49702.png";